/* ==========================================================
   Pro Ase Sports | assets/pa-cart.js
   Conversion cart drawer controller.
   - One request per action: cart/add, cart/change and
     cart/update return the re-rendered "cart-drawer" section
     (Shopify bundled section rendering).
   - Public API: window.PACart.open/close/refresh/add/change
     Legacy aliases kept: openCart, closeCart, fetchCart, ProAseCart.
   ========================================================== */
(function () {
  'use strict';

  var SECTION = 'cart-drawer';
  var ROOT_URL = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var queue = Promise.resolve();
  var busyCount = 0;
  var lastFocus = null;
  var gkLoaded = false;
  var nativeMode = false;
  var noteTimer = null;

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function root() { return document.getElementById('PACart'); }
  function panel() { var r = root(); return r ? $('.pa-cd__panel', r) : null; }
  function isOpen() { var r = root(); return !!(r && r.classList.contains('is-open')); }

  /* ── Toast ── */
  var toastTimer;
  function toast(msg) {
    var t = document.getElementById('PACartToast');
    if (!t || !msg) return;
    t.textContent = msg;
    t.classList.add('is-show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-show'); }, 2800);
  }

  function setBusy(on) {
    busyCount = Math.max(0, busyCount + (on ? 1 : -1));
    var r = root();
    if (r) r.classList.toggle('is-busy', busyCount > 0);
  }

  /* ── Open / close ── */
  function open() {
    var r = root();
    if (!r || isOpen()) return;
    /* On the full cart page the drawer would show a duplicate cart: reload the page instead */
    if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
    lastFocus = document.activeElement;
    r.classList.add('is-open');
    r.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('pa-cd-lock');
    $all('[data-pa-cart-open], #cartToggle').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var p = panel();
    if (p) setTimeout(function () { p.focus({ preventScroll: true }); }, 60);
    syncCheckoutMode();
    document.dispatchEvent(new CustomEvent('pa:cart:open'));
  }

  function close() {
    var r = root();
    if (!r || !isOpen()) return;
    r.classList.remove('is-open');
    r.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('pa-cd-lock');
    $all('[data-pa-cart-open], #cartToggle').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus({ preventScroll: true });
    document.dispatchEvent(new CustomEvent('pa:cart:close'));
  }

  /* ── Badges ── */
  function updateBadges(count) {
    $all('#cartCount, .cart-badge, .cart-count, [data-cart-count-badge]').forEach(function (b) {
      b.textContent = count;
      b.setAttribute('aria-hidden', count > 0 ? 'false' : 'true');
      b.classList.toggle('is-hidden', count === 0);
      b.classList.remove('is-bump');
      void b.offsetWidth;
      if (count > 0) b.classList.add('is-bump');
    });
    var toggle = document.getElementById('cartToggle');
    if (toggle) toggle.setAttribute('aria-label', 'Open cart, ' + count + (count === 1 ? ' item' : ' items'));
    document.body.setAttribute('data-cart-count', count);
  }

  /* ── GoKwik checkout button handling ── */
  function gkReady() { return gkLoaded || typeof window.onCheckoutClick === 'function'; }

  function syncCheckoutMode() {
    var r = root();
    if (!r) return;
    var gkWrap = $('[data-pa-gk]', r);
    var native = $('[data-pa-native-checkout]', r);
    if (!gkWrap) { if (native) native.hidden = false; return; }
    if (nativeMode) {
      gkWrap.hidden = true;
      if (native) native.hidden = false;
      return;
    }
    if (gkReady()) {
      $all('.gokwik-checkout button', gkWrap).forEach(function (b) {
        b.disabled = false;
        b.classList.remove('disabled');
      });
    }
  }

  window.addEventListener('gokwikLoaded', function () { gkLoaded = true; syncCheckoutMode(); });
  /* If GoKwik has not loaded 8s after page load, fall back to Shopify checkout so the cart never dead-ends */
  window.addEventListener('load', function () {
    setTimeout(function () {
      var r = root();
      if (r && r.dataset.gokwik === 'true' && !gkReady()) { nativeMode = true; syncCheckoutMode(); }
    }, 8000);
  });

  /* ── Rendering ── */
  function render(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.getElementById('PACart');
    var cur = root();
    if (!fresh || !cur) return;
    var oldScroll = $('[data-pa-cart-scroll]', cur);
    var top = oldScroll ? oldScroll.scrollTop : 0;
    var codeMsg = $('[data-pa-code-msg]', cur);
    var keepMsg = codeMsg && !codeMsg.hidden ? { text: codeMsg.textContent, cls: codeMsg.className } : null;

    $('#PACartInner', cur).innerHTML = $('#PACartInner', fresh).innerHTML;
    cur.dataset.count = fresh.dataset.count;
    cur.dataset.codes = fresh.dataset.codes;

    var newScroll = $('[data-pa-cart-scroll]', cur);
    if (newScroll) newScroll.scrollTop = top;
    if (keepMsg) {
      var m = $('[data-pa-code-msg]', cur);
      if (m) { m.textContent = keepMsg.text; m.className = keepMsg.cls; m.hidden = false; }
    }

    var count = parseInt(fresh.dataset.count, 10) || 0;
    updateBadges(count);
    syncCheckoutMode();
    document.dispatchEvent(new CustomEvent('pa:cart:updated', { detail: { count: count } }));
  }

  function post(url, data, withSection) {
    var body = Object.assign({}, data);
    if (withSection !== false) {
      body.sections = SECTION;
      body.sections_url = window.location.pathname;
    }
    return fetch(ROOT_URL.replace(/\/$/, '') + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (json) {
        if (!res.ok) {
          var err = new Error(json.description || json.message || 'Something went wrong. Please try again.');
          err.status = res.status;
          throw err;
        }
        return json;
      });
    });
  }

  function enqueue(fn) {
    queue = queue.then(fn, fn);
    return queue;
  }

  function refresh(opts) {
    return enqueue(function () {
      return fetch(ROOT_URL + '?sections=' + SECTION, { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (json) {
          render(json[SECTION]);
          if (opts && opts.open) open();
        })
        .catch(function () {});
    });
  }

  function add(items, opts) {
    setBusy(true);
    var p = new Promise(function (resolve, reject) {
      enqueue(function () {
        return post('/cart/add.js', { items: items })
          .then(function (json) {
            render(json.sections && json.sections[SECTION]);
            if (!opts || opts.open !== false) open();
            resolve(json);
          })
          .catch(function (err) { toast(err.message); reject(err); })
          .finally(function () { setBusy(false); });
      });
    });
    return p;
  }

  function change(key, qty) {
    var r = root();
    var item = r ? $('.pa-cd__item[data-key="' + (window.CSS && CSS.escape ? CSS.escape(key) : key) + '"]', r) : null;
    if (item) item.classList.add('is-busy');
    setBusy(true);
    return enqueue(function () {
      return post('/cart/change.js', { id: key, quantity: qty })
        .then(function (json) { render(json.sections && json.sections[SECTION]); })
        .catch(function (err) {
          if (item) {
            item.classList.remove('is-busy');
            var e = $('.pa-cd__item-error', item);
            if (e) { e.textContent = err.message; e.hidden = false; }
          }
          toast(err.message);
        })
        .finally(function () { setBusy(false); });
    });
  }

  /* ── Discount codes ── */
  function currentCodes() {
    var r = root();
    var raw = r ? (r.dataset.codes || '') : '';
    return raw.split(',').map(function (c) { return c.trim(); }).filter(Boolean);
  }

  function setCodeMsg(text, ok) {
    var m = $('[data-pa-code-msg]', root());
    if (!m) { toast(text); return; }
    m.textContent = text;
    m.className = 'pa-cd__coupon-msg ' + (ok ? 'is-ok' : 'is-err');
    m.hidden = !text;
  }

  function applyCode(code) {
    code = (code || '').trim();
    if (!code) { setCodeMsg('Please enter a coupon code.', false); return; }
    var before = currentCodes();
    var exists = before.some(function (c) { return c.toLowerCase() === code.toLowerCase(); });
    if (exists) { setCodeMsg(code.toUpperCase() + ' is already applied.', true); return; }
    setBusy(true);
    enqueue(function () {
      return post('/cart/update.js', { discount: before.concat([code]).join(',') })
        .then(function (json) {
          var codes = Array.isArray(json.discount_codes) ? json.discount_codes : null;
          var hit = codes ? codes.filter(function (c) { return (c.code || '').toLowerCase() === code.toLowerCase(); })[0] : null;
          var applied = hit ? hit.applicable !== false : null;
          render(json.sections && json.sections[SECTION]);
          if (applied === null) {
            applied = currentCodes().some(function (c) { return c.toLowerCase() === code.toLowerCase(); });
          }
          if (applied) {
            setCodeMsg(code.toUpperCase() + ' applied successfully!', true);
          } else {
            setCodeMsg(code.toUpperCase() + ' is not valid for the items in your cart.', false);
            /* remove the rejected code so it doesn't linger at checkout */
            return post('/cart/update.js', { discount: before.join(',') }).then(function (j2) {
              render(j2.sections && j2.sections[SECTION]);
              setCodeMsg(code.toUpperCase() + ' is not valid for the items in your cart.', false);
            });
          }
        })
        .catch(function (err) { setCodeMsg(err.message, false); })
        .finally(function () { setBusy(false); });
    });
  }

  function removeCode(code) {
    var rest = currentCodes().filter(function (c) { return c.toLowerCase() !== code.toLowerCase(); });
    setBusy(true);
    enqueue(function () {
      return post('/cart/update.js', { discount: rest.join(',') })
        .then(function (json) { render(json.sections && json.sections[SECTION]); setCodeMsg('', true); })
        .catch(function (err) { toast(err.message); })
        .finally(function () { setBusy(false); });
    });
  }

  /* ── Events (delegated, survive re-renders) ── */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var opener = t.closest('[data-pa-cart-open], #cartToggle, [data-open-cart]');
    if (opener) { e.preventDefault(); open(); return; }

    if (t.closest('[data-pa-cart-close]')) { e.preventDefault(); close(); return; }

    var qtyBtn = t.closest('[data-pa-qty]');
    if (qtyBtn) {
      var it = qtyBtn.closest('.pa-cd__item');
      if (!it) return;
      var next = (parseInt(it.dataset.qty, 10) || 0) + parseInt(qtyBtn.dataset.paQty, 10);
      change(it.dataset.key, Math.max(0, next));
      return;
    }

    var rm = t.closest('[data-pa-remove]');
    if (rm) {
      var row = rm.closest('.pa-cd__item');
      if (row) change(row.dataset.key, 0);
      return;
    }

    var offer = t.closest('[data-pa-code-apply]');
    if (offer) { applyCode(offer.dataset.paCodeApply); return; }

    if (t.closest('[data-pa-code-submit]')) {
      var input = $('[data-pa-code-input]', root());
      applyCode(input ? input.value : '');
      return;
    }

    var chipRm = t.closest('[data-pa-code-remove]');
    if (chipRm) { removeCode(chipRm.dataset.paCodeRemove); return; }

    var upBtn = t.closest('[data-pa-upsell-add]');
    if (upBtn) {
      var card = upBtn.closest('[data-pa-upsell]');
      var field = card ? $('[data-pa-upsell-variant]', card) : null;
      var id = field ? field.value : '';
      if (!id) {
        if (field) {
          field.classList.remove('is-error'); void field.offsetWidth; field.classList.add('is-error');
          field.focus();
        }
        toast('Please select a size first');
        return;
      }
      upBtn.classList.add('is-busy');
      add([{ id: parseInt(id, 10), quantity: 1 }], { open: true }).catch(function () {}).finally(function () {
        upBtn.classList.remove('is-busy');
      });
    }
  });

  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('.pa-cd__up-select')) e.target.classList.remove('is-error');
  });

  document.addEventListener('input', function (e) {
    if (!e.target || !e.target.matches || !e.target.matches('[data-pa-note]')) return;
    var val = e.target.value;
    clearTimeout(noteTimer);
    noteTimer = setTimeout(function () { post('/cart/update.js', { note: val }, false).catch(function () {}); }, 700);
  });

  document.addEventListener('keydown', function (e) {
    if (!isOpen()) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key === 'Enter' && e.target && e.target.matches && e.target.matches('[data-pa-code-input]')) {
      e.preventDefault();
      applyCode(e.target.value);
      return;
    }
    if (e.key === 'Tab') {
      var p = panel();
      if (!p) return;
      var f = $all('a[href], button:not([disabled]), input:not([type="hidden"]), select, textarea, summary, [tabindex]:not([tabindex="-1"])', p)
        .filter(function (n) { return n.offsetParent !== null && !n.hidden; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === p)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* Legacy events from older snippets / apps */
  document.addEventListener('cart:add', function () { refresh({ open: true }); });
  document.addEventListener('pa:cart:refresh', function () { refresh(); });

  /* Theme editor: open the drawer when its section is selected */
  document.addEventListener('shopify:section:select', function (e) { if (e.detail && e.detail.sectionId === SECTION) open(); });
  document.addEventListener('shopify:section:deselect', function (e) { if (e.detail && e.detail.sectionId === SECTION) close(); });

  /* Back/forward cache: page restored with a stale cart */
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });

  /* ── Public API ── */
  window.PACart = { open: open, close: close, refresh: refresh, add: add, change: change, applyCode: applyCode, toast: toast };
  window.openCart = open;
  window.closeCart = close;
  window.fetchCart = refresh;
  window.ProAseCart = { open: open, close: close, refresh: refresh };

  syncCheckoutMode();
})();
